module.exports = __webpack_public_path__ + "static/media/dolly-googl.c3ef2a79.svg";